import React, { useEffect, useState } from "react";
import { useLoader } from "../context/LoaderContext";
// import { IBannerData, IVideoData } from "../exports/interfaces";
// import { fetchArchiveBanner, fetchVideoData } from "../api/ArchiveApi";
import {
  IBannerData,
  IMemberListData,
  IVideoFilesData,
} from "../exports/interfaces";
import { fetchArchiveBanner, fetchVideoFilesData } from "../api/ArchiveApi";
import { dynamicFailed } from "../hooks/useToast";
import ArchiveBanner from "../components/archive/ArchiveBanner";
import ArchiveVideos from "../components/archive/ArchiveVideos";
import { fetchMemberLists } from "../api/MemberApi";
import { useUserDataContext } from "../context/UserDataContext";
// import ArchiveVideos from "../components/archive/ArchiveVideos";

const Archive = () => {
  const { setLoading } = useLoader();
  const { userData } = useUserDataContext();
  const [archiveBannerData, setArchiveBannerData] = useState<IBannerData[]>([]);
  const [archiveVideoData, setArchiveVideoData] = useState<IVideoFilesData[]>(
    [],
  );
  const [listMemberData, setListMemberData] = useState<IMemberListData[]>([]);
  const [matchedMember, setMatchedMember] = useState<
    IMemberListData | undefined
  >(undefined);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchArchiveBanner(),
      fetchVideoFilesData(),
      fetchMemberLists(),
    ])
      // Promise.all([fetchArchiveBanner()])
      .then(([archiveBannerData, videoData, listMemberData]) => {
        setArchiveBannerData(archiveBannerData);
        setArchiveVideoData(videoData);
        setListMemberData(listMemberData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  useEffect(() => {
    if (userData?.data?.id && listMemberData.length > 0) {
      const match = listMemberData.find(
        (member) => member?.attributes?.sis_id === String(userData?.data?.id),
      );
      setMatchedMember(match || undefined);
    }
  }, [userData, listMemberData]);

  return (
    <>
      <ArchiveBanner archiveBannerData={archiveBannerData} />
      <ArchiveVideos
        archiveVideoData={archiveVideoData}
        matchedMember={matchedMember}
      />
    </>
  );
};

export default Archive;
